
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[id]",
      function () {
        return require("private-next-pages/brands/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[id]"])
      });
    }
  